<template>
  <div class="value-filter">
    <div class="city-parent">
      <div class="city">Highway</div>
      <div class="buttons-wrapper">
        <div class="buttons7">
          <div class="div4">
            {{ Number(sliderValueHighway[0]) }} -
            {{ Number(sliderValueHighway[1]) }}
          </div>
          <div class="mpgmpge">{{ mPGMPGe }}</div>
        </div>
      </div>
    </div>
    <div class="range-selector">
      <div class="graph">
        <div
          v-for="index in 91"
          :key="index + 9"
          :class="'graph-child-highway graph-child-highway' + (index + 9)"
        ></div>
      </div>
      <div style="width: 100%">
        <vue-slider
          style="
            padding: 0px 0px;
            width: 100%;
            height: 4px;
            display: flex;
            justify-content: center;
          "
          v-model="sliderValueHighway"
          :dot-options="dotOptions"
          :order="false"
          :tooltip="'none'"
          :min="10"
          :max="100"
          @change="updateGraph"
          @drag-end="checkThumbPosition"
        >
          <template #dot="{ index }">
            <div v-if="index === 0 || index === 1" class="custom-slider-thumb">
              <img
                loading="lazy"
                alt=""
                src="../../assets/custom-slider-icon.svg"
              />
            </div>
          </template>
        </vue-slider>
        <div style="display: flex; justify-content: space-between">
          <span>10</span>
          <span>100</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, onMounted } from "vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

const props = defineProps({
  mPGMPGe: String,
  min: String,
  max: String,
});

const emits = defineEmits(["highwaySliderValue"]);
const sliderValueHighway = ref([props.min, props.max]);
const dotOptions = [{ disabled: false, strokeWidth: 1 }, { disabled: false }];

const updateGraph = (value) => {
  const minValue = Math.round(value[0]);
  const maxValue = Math.round(value[1]);

  sliderValueHighway.value = [minValue, maxValue];
  if (props.min != minValue || props.max != maxValue) {
    emits("highwaySliderValue", sliderValueHighway);
  }

  // Resetting all graph colors to default gray
  const allGraphItems = document.querySelectorAll(".graph-child-highway");
  allGraphItems.forEach((item) => {
    item.style.backgroundColor = "var(--gray-medium)";
  });

  // Marking graph items between min and max as blue
  for (let i = minValue; i <= maxValue; i++) {
    const graphChild = document.querySelector(`.graph-child-highway${i}`);
    if (graphChild)
      graphChild.style.backgroundColor = "var(--primary-accent-base)";
  }
};

const checkThumbPosition = () => {
  // Check if min thumb crosses max thumb
  if (sliderValueHighway.value[0] > sliderValueHighway.value[1]) {
    // Adjust min thumb to be equal to max thumb
    sliderValueHighway.value[0] = sliderValueHighway.value[1] - 5;
    updateGraph(sliderValueHighway.value);
  }
};

onMounted(() => {
  updateGraph(sliderValueHighway.value);
});
</script>

<style scoped>
.custom-slider-thumb {
  position: relative;
  width: 14px;
  height: 14px;
  cursor: pointer;
  justify-content: center;
  display: flex;
}

.city {
  height: 23px;
  width: 80px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
  flex-shrink: 0;
}
.div4 {
  align-self: stretch;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 27px;
  font-weight: 600;
  display: inline-block;
}
.mpgmpge {
  height: 21px;
  position: relative;
  font-size: var(--paragraph-primary-medium-regular-size);
  line-height: 21px;
  display: flex;
  align-items: center;
}
.buttons7 {
  flex: 1;
  border-radius: var(--br-9xs);
  background-color: var(--white-light);
  border: 0.5px solid var(--primary-accent-base);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 15px;
  gap: var(--gap-4xs);
}
.buttons-wrapper {
  height: 33px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}
.city-parent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* padding: 0px var(--padding-102xl) 0px 0px; */
  gap: var(--gap-3xs);
}
.slider-icon {
  align-self: stretch;
  height: 24px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
}

.graph-child-highway {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway1,
.graph-child-highway26,
.graph-child-highway51,
.graph-child-highway76 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway2,
.graph-child-highway27,
.graph-child-highway52,
.graph-child-highway77 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway3,
.graph-child-highway28,
.graph-child-highway53,
.graph-child-highway78 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway4,
.graph-child-highway29,
.graph-child-highway54,
.graph-child-highway79 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway5,
.graph-child-highway30,
.graph-child-highway55,
.graph-child-highway80 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway6,
.graph-child-highway31,
.graph-child-highway56,
.graph-child-highway81 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway7,
.graph-child-highway32,
.graph-child-highway57,
.graph-child-highway82 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway8,
.graph-child-highway33,
.graph-child-highway58,
.graph-child-highway83 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway9,
.graph-child-highway34,
.graph-child-highway59,
.graph-child-highway84 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}
.graph-child-highway10,
.graph-child-highway35,
.graph-child-highway60,
.graph-child-highway85 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway11,
.graph-child-highway36,
.graph-child-highway61,
.graph-child-highway86 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway12,
.graph-child-highway37,
.graph-child-highway62,
.graph-child-highway87 {
  height: 21px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway13,
.graph-child-highway38,
.graph-child-highway63,
.graph-child-highway88 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway14,
.graph-child-highway39,
.graph-child-highway64,
.graph-child-highway89 {
  height: 30px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway15,
.graph-child-highway40,
.graph-child-highway65,
.graph-child-highway90 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway16,
.graph-child-highway41,
.graph-child-highway66,
.graph-child-highway91 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway17,
.graph-child-highway42,
.graph-child-highway67,
.graph-child-highway92 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway18,
.graph-child-highway43,
.graph-child-highway68,
.graph-child-highway93 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway19,
.graph-child-highway44,
.graph-child-highway69,
.graph-child-highway94 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway20,
.graph-child-highway45,
.graph-child-highway70,
.graph-child-highway95 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway21,
.graph-child-highway46,
.graph-child-highway71,
.graph-child-highway96 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway22,
.graph-child-highway47,
.graph-child-highway72,
.graph-child-highway97 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway23,
.graph-child-highway48,
.graph-child-highway73,
.graph-child-highway98 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway24,
.graph-child-highway49,
.graph-child-highway74,
.graph-child-highway99 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-highway25,
.graph-child-highway50,
.graph-child-highway75,
.graph-child-highway100 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.table-layout {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}
.graph {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: var(--gap-11xs);
  width: 100%;
}
.range-selector {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-6xs);
  box-sizing: border-box;
  max-width: 100%;
  text-align: center;
}
.value-filter {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-21xl);
  flex-shrink: 0;
  max-width: 100%;
  text-align: left;
  font-size: var(--paragraph-secondary-large-semibold-size);
  color: var(--black-default);
  font-family: var(--paragraph-secondary-large-semibold);
}

</style>
